// extracted by mini-css-extract-plugin
module.exports = {"form":"CraeteProfileStep2_form__2M23W","inviteText":"CraeteProfileStep2_inviteText__w78D0"};